<div class="scale-control">
  <img [src]="'assets/img/' + icon()" [alt]="icon()" />

  @if (barWidth() && formattedDistance()) {
    <span class="bar" [style.width.px]="barWidth()"></span>
    <span>{{ formattedDistance() }}</span>
  }
</div>
